import React from "react";
import {Stomp} from "@stomp/stompjs";
import AuthService from "../services/AuthService"
import {apiFacade} from "./ApiFacade";
import {EventType} from "./Constants";
import {WS_URL} from "./Configuration";

/**
 * Web socket manager component and context. Encloses its children in WebSocketContext.Provider, to provide this instance
 * via a hook
 * @author dame.gjorgjievski
 * @type {React.Context<null>}
 */

export const WebSocketContext = React.createContext(null);
export const useWebSocket = () => React.useContext(WebSocketContext);

export default class WebSocketManager extends React.Component {

    static QUEUE_MESSAGES = "/user/queue/messages"

    constructor(props) {
        super(props);
        const URL = !!WS_URL?WS_URL:`${window.location.protocol === "https:"?"wss:":"ws:"}//${window.location.host}/ws`
        this.client = Stomp.client(URL);
        this.client.reconnect_delay = 5000;
        this.client.debug = function(str) { console.log("WebSocketClient", str) }
    }

    /**
     * Connects the websocket to remote endpoint
     */
    connect() {
        // if(this.client.connected) this.client.disconnect()
        console.log("connecting", this.client)
        let user = AuthService.user()
        if(!user) return;
        document.cookie = 'Authorization=' + user.token + '; path=/';
        console.log("connecting client", this.client)
        let client = this.client
        client.connect({ user: user.email }, (e) => {
            console.log("ws connect", e)
            client.subscribe(WebSocketManager.QUEUE_MESSAGES, function (message) {
                apiFacade.onEvent({action: EventType.MESSAGE, data: {message: message.body}})
                console.log("ws message in", message)
            })
        }, (e) => {
            console.error("ws connect error", e)
        });
    }

    /**
     * Disconnects the websocket from remote endpoint, if connected otherwise it does nothing
     */
    disconnect() {
        if(this.client.connected) this.client.disconnect()
    }

    render() {
        return (
            <WebSocketContext.Provider value={this}>
                {this.props.children}
            </WebSocketContext.Provider>
        )
    }
}